import { cacheCancelWorkspaceDowngrade } from '@/graphql/cache/cache-mutations';
import { useCancelWorkspaceDowngradeMutation } from '@/types/generated/graphql';
import { useModal } from '@shared/hooks/use-modal';
import { notification } from 'antd';
import { UseScheduledDowngradeOptions } from '../../banner.types';

export const useScheduledDowngrade = ({ workspaceSubscriptionId }: UseScheduledDowngradeOptions = {}) => {
  const { open, handleOpen, handleClose } = useModal();

  const [_cancelWorkspaceDowngrade, { loading: downgradeLoading }] = useCancelWorkspaceDowngradeMutation({
    onCompleted: (data) => {
      notification.success({
        message: data?.cancelWorkspaceDowngrade?.message,
      });
    },
    onError: (error) => {
      notification.error({
        message: error.message,
      });
    },
  });

  const handleDowngradeCancelled = async () => {
    if (!workspaceSubscriptionId) return;

    await _cancelWorkspaceDowngrade({
      update: (cache) => {
        cacheCancelWorkspaceDowngrade(cache, workspaceSubscriptionId);
      },
    });
  };

  return {
    open,
    handleOpen,
    handleClose,
    handleDowngradeCancelled,
    downgradeLoading,
  };
};
